import { useEffect } from 'react';

export const useSaveResultEffect = (time, addResult, WPM, CPM, mstk, acc, spScore, misPenal, points) => {
  useEffect(() => {
    if (time <= 0) {
      addResult({ WPM, CPM, mstk, acc, spScore, misPenal, points });
    }
  }, [time, WPM, CPM, mstk, acc, spScore, misPenal, points]);
};

export const useTimerEffect = (time, timer, setTime) => {
  useEffect(() => {
    if (timer.current && time > 0) {
      timer.current = setTimeout(() => setTime(t => t - 1), 1000);
    }
    if (time <= 0) {
      clearTimeout(timer.current);
      return;
    }
  }, [time]);
};

export const useKeyDownEffect = (inputRef) => {
  useEffect(() => {
    const handleKeyDown = () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
};

export const useFocusEffect = (inputRef) => {
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
};
